
export default {
  name: "Radio",
  props: {
    label: {},
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    option: {
      required: true
    }
  },
  computed: {
    isChecked() {
      return this.option === this.value;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.option);
    }
  }
};
